// Seva UI translations
// Add new keys here and they'll be available via the t() function

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'pl', label: 'Polski' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'ru', label: 'Русский' },
  { code: 'ar', label: 'العربية', rtl: true },
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '中文' },
  { code: 'ko', label: '한국어' },
];

export const TRANSLATIONS = {
  en: {
    // Nav groups
    operations: 'Operations',
    venue: 'Venue',
    insights: 'Insights',
    manage: 'Manage',
    // Nav items
    today: 'Today',
    thisWeek: 'This Week',
    reservations: 'Reservations',
    history: 'History',
    calendar: 'Calendar',
    newBooking: 'New Booking',
    aiBookings: 'AI Bookings',
    floorPlan: 'Floor Plan',
    capacity: 'Capacity',
    analytics: 'Analytics',
    waitlist: 'Waitlist',
    tables: 'Tables',
    menu: 'Menu',
    settings: 'Settings',
    signOut: 'Sign out',
    management: 'Management',
    // Common
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    loading: 'Loading…',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    done: 'Done',
    confirm: 'Confirm',
    // Onboarding
    onb_welcome: "Welcome to Seva",
    onb_welcome_sub: "Let's get your restaurant set up in a few quick steps so the AI knows how to help your customers.",
    onb_step_tables: 'Add your tables',
    onb_step_hours: 'Set your opening hours',
    onb_lets_go: "Let's go →",
    onb_tables_title: 'Add your tables',
    onb_tables_sub: 'Give each table a name or number and set how many seats it has. You can add more later.',
    onb_col_name: 'Name / Number',
    onb_col_seats: 'Seats',
    onb_col_area: 'Area / Label',
    onb_add_table: '+ Add another table',
    onb_hours_title: 'Your opening hours',
    onb_hours_sub: 'The AI uses these to know when to accept bookings. You can update them any time in Settings.',
    onb_finish: 'Finish setup →',
    onb_done_title: "You're all set!",
    onb_done_sub: 'Seva is ready to take reservations. You can always add more tables, adjust hours, and fine-tune everything in Settings.',
    onb_go_dashboard: 'Go to dashboard →',
    onb_lang_title: 'Choose your language',
    onb_lang_sub: 'Select the language for the staff app. You can change this later in Settings.',
    // Days
    monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday',
    thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday', sunday: 'Sunday',
    closed: 'Closed',
  },

  es: {
    operations: 'Operaciones', venue: 'Local', insights: 'Análisis', manage: 'Gestión',
    today: 'Hoy', thisWeek: 'Esta semana', reservations: 'Reservas', history: 'Historial', newBooking: 'Nueva reserva',
    aiBookings: 'Reservas IA', floorPlan: 'Plano', capacity: 'Capacidad',
    analytics: 'Estadísticas', waitlist: 'Lista de espera', tables: 'Mesas', menu: 'Menú',
    settings: 'Configuración', signOut: 'Cerrar sesión', management: 'Gestión',
    save: 'Guardar', saving: 'Guardando…', cancel: 'Cancelar', loading: 'Cargando…',
    create: 'Crear', delete: 'Eliminar', edit: 'Editar', back: 'Atrás', next: 'Siguiente', done: 'Listo', confirm: 'Confirmar',
    onb_welcome: 'Bienvenido a Seva', onb_welcome_sub: 'Configuremos tu restaurante en unos pocos pasos rápidos.',
    onb_step_tables: 'Añadir tus mesas', onb_step_hours: 'Configurar horario de apertura', onb_lets_go: 'Empezar →',
    onb_tables_title: 'Añadir tus mesas', onb_tables_sub: 'Dale a cada mesa un nombre o número y el número de asientos. Puedes añadir más después.',
    onb_col_name: 'Nombre / Número', onb_col_seats: 'Asientos', onb_col_area: 'Zona',
    onb_add_table: '+ Añadir otra mesa', onb_hours_title: 'Tu horario de apertura',
    onb_hours_sub: 'La IA usa esto para saber cuándo aceptar reservas. Puedes cambiarlo en Configuración.',
    onb_finish: 'Terminar configuración →', onb_done_title: '¡Todo listo!',
    onb_done_sub: 'Seva está listo para tomar reservas. Puedes ajustar todo en Configuración.',
    onb_go_dashboard: 'Ir al panel →', onb_lang_title: 'Elige tu idioma', onb_lang_sub: 'Selecciona el idioma de la app. Puedes cambiarlo después en Configuración.',
    monday: 'Lunes', tuesday: 'Martes', wednesday: 'Miércoles', thursday: 'Jueves',
    friday: 'Viernes', saturday: 'Sábado', sunday: 'Domingo', closed: 'Cerrado',
  },

  fr: {
    operations: 'Opérations', venue: 'Établissement', insights: 'Statistiques', manage: 'Gestion',
    today: "Aujourd'hui", thisWeek: 'Cette semaine', reservations: 'Réservations', history: 'Historique', newBooking: 'Nouvelle réservation',
    aiBookings: 'Réservations IA', floorPlan: 'Plan de salle', capacity: 'Capacité',
    analytics: 'Analyses', waitlist: "Liste d'attente", tables: 'Tables', menu: 'Menu',
    settings: 'Paramètres', signOut: 'Se déconnecter', management: 'Gestion',
    save: 'Enregistrer', saving: 'Enregistrement…', cancel: 'Annuler', loading: 'Chargement…',
    create: 'Créer', delete: 'Supprimer', edit: 'Modifier', back: 'Retour', next: 'Suivant', done: 'Terminé', confirm: 'Confirmer',
    onb_welcome: 'Bienvenue sur Seva', onb_welcome_sub: "Configurons votre restaurant en quelques étapes rapides.",
    onb_step_tables: 'Ajouter vos tables', onb_step_hours: "Définir vos horaires d'ouverture", onb_lets_go: 'Commencer →',
    onb_tables_title: 'Ajouter vos tables', onb_tables_sub: 'Donnez à chaque table un nom ou un numéro et définissez le nombre de places. Vous pourrez en ajouter plus tard.',
    onb_col_name: 'Nom / Numéro', onb_col_seats: 'Places', onb_col_area: 'Zone',
    onb_add_table: '+ Ajouter une table', onb_hours_title: "Vos horaires d'ouverture",
    onb_hours_sub: "L'IA utilise ces informations pour savoir quand accepter des réservations.",
    onb_finish: 'Terminer la configuration →', onb_done_title: 'Tout est prêt !',
    onb_done_sub: 'Seva est prêt à prendre des réservations. Vous pouvez tout ajuster dans Paramètres.',
    onb_go_dashboard: 'Aller au tableau de bord →', onb_lang_title: 'Choisissez votre langue', onb_lang_sub: "Sélectionnez la langue de l'application. Vous pourrez la changer dans Paramètres.",
    monday: 'Lundi', tuesday: 'Mardi', wednesday: 'Mercredi', thursday: 'Jeudi',
    friday: 'Vendredi', saturday: 'Samedi', sunday: 'Dimanche', closed: 'Fermé',
  },

  it: {
    operations: 'Operazioni', venue: 'Locale', insights: 'Analisi', manage: 'Gestione',
    today: 'Oggi', thisWeek: 'Questa settimana', reservations: 'Prenotazioni', history: 'Storico', newBooking: 'Nuova prenotazione',
    aiBookings: 'Prenotazioni IA', floorPlan: 'Planimetria', capacity: 'Capacità',
    analytics: 'Statistiche', waitlist: 'Lista d\'attesa', tables: 'Tavoli', menu: 'Menu',
    settings: 'Impostazioni', signOut: 'Esci', management: 'Gestione',
    save: 'Salva', saving: 'Salvataggio…', cancel: 'Annulla', loading: 'Caricamento…',
    create: 'Crea', delete: 'Elimina', edit: 'Modifica', back: 'Indietro', next: 'Avanti', done: 'Fatto', confirm: 'Conferma',
    onb_welcome: 'Benvenuto su Seva', onb_welcome_sub: 'Configuriamo il tuo ristorante in pochi semplici passi.',
    onb_step_tables: 'Aggiungi i tuoi tavoli', onb_step_hours: 'Imposta gli orari di apertura', onb_lets_go: 'Iniziamo →',
    onb_tables_title: 'Aggiungi i tuoi tavoli', onb_tables_sub: 'Dai a ogni tavolo un nome o numero e il numero di posti. Puoi aggiungerne altri in seguito.',
    onb_col_name: 'Nome / Numero', onb_col_seats: 'Posti', onb_col_area: 'Area',
    onb_add_table: '+ Aggiungi un altro tavolo', onb_hours_title: 'I tuoi orari di apertura',
    onb_hours_sub: "L'IA usa queste informazioni per sapere quando accettare prenotazioni.",
    onb_finish: 'Completa la configurazione →', onb_done_title: 'Tutto pronto!',
    onb_done_sub: 'Seva è pronto per accettare prenotazioni. Puoi modificare tutto nelle Impostazioni.',
    onb_go_dashboard: 'Vai alla dashboard →', onb_lang_title: 'Scegli la tua lingua', onb_lang_sub: "Seleziona la lingua dell'app. Puoi cambiarla in seguito nelle Impostazioni.",
    monday: 'Lunedì', tuesday: 'Martedì', wednesday: 'Mercoledì', thursday: 'Giovedì',
    friday: 'Venerdì', saturday: 'Sabato', sunday: 'Domenica', closed: 'Chiuso',
  },

  de: {
    operations: 'Betrieb', venue: 'Lokal', insights: 'Auswertungen', manage: 'Verwaltung',
    today: 'Heute', thisWeek: 'Diese Woche', reservations: 'Reservierungen', history: 'Verlauf', newBooking: 'Neue Buchung',
    aiBookings: 'KI-Buchungen', floorPlan: 'Raumplan', capacity: 'Kapazität',
    analytics: 'Statistiken', waitlist: 'Warteliste', tables: 'Tische', menu: 'Speisekarte',
    settings: 'Einstellungen', signOut: 'Abmelden', management: 'Verwaltung',
    save: 'Speichern', saving: 'Speichern…', cancel: 'Abbrechen', loading: 'Laden…',
    create: 'Erstellen', delete: 'Löschen', edit: 'Bearbeiten', back: 'Zurück', next: 'Weiter', done: 'Fertig', confirm: 'Bestätigen',
    onb_welcome: 'Willkommen bei Seva', onb_welcome_sub: 'Richten wir Ihr Restaurant in wenigen Schritten ein.',
    onb_step_tables: 'Tische hinzufügen', onb_step_hours: 'Öffnungszeiten festlegen', onb_lets_go: 'Los geht\'s →',
    onb_tables_title: 'Tische hinzufügen', onb_tables_sub: 'Geben Sie jedem Tisch einen Namen oder eine Nummer und die Anzahl der Plätze an.',
    onb_col_name: 'Name / Nummer', onb_col_seats: 'Plätze', onb_col_area: 'Bereich',
    onb_add_table: '+ Weiteren Tisch hinzufügen', onb_hours_title: 'Ihre Öffnungszeiten',
    onb_hours_sub: 'Die KI nutzt diese Informationen, um zu wissen, wann Buchungen akzeptiert werden.',
    onb_finish: 'Einrichtung abschließen →', onb_done_title: 'Alles bereit!',
    onb_done_sub: 'Seva ist bereit, Reservierungen entgegenzunehmen. Sie können alles in den Einstellungen anpassen.',
    onb_go_dashboard: 'Zum Dashboard →', onb_lang_title: 'Sprache wählen', onb_lang_sub: 'Wählen Sie die Sprache der App. Sie können diese später in den Einstellungen ändern.',
    monday: 'Montag', tuesday: 'Dienstag', wednesday: 'Mittwoch', thursday: 'Donnerstag',
    friday: 'Freitag', saturday: 'Samstag', sunday: 'Sonntag', closed: 'Geschlossen',
  },

  pt: {
    operations: 'Operações', venue: 'Estabelecimento', insights: 'Análises', manage: 'Gestão',
    today: 'Hoje', thisWeek: 'Esta semana', reservations: 'Reservas', newBooking: 'Nova reserva',
    aiBookings: 'Reservas IA', floorPlan: 'Planta', capacity: 'Capacidade',
    analytics: 'Estatísticas', waitlist: 'Lista de espera', tables: 'Mesas', menu: 'Cardápio',
    settings: 'Configurações', signOut: 'Sair', management: 'Gestão',
    save: 'Guardar', saving: 'A guardar…', cancel: 'Cancelar', loading: 'A carregar…',
    create: 'Criar', delete: 'Eliminar', edit: 'Editar', back: 'Voltar', next: 'Seguinte', done: 'Concluído', confirm: 'Confirmar',
    onb_welcome: 'Bem-vindo ao Seva', onb_welcome_sub: 'Vamos configurar o seu restaurante em poucos passos.',
    onb_step_tables: 'Adicionar mesas', onb_step_hours: 'Definir horário de funcionamento', onb_lets_go: 'Começar →',
    onb_tables_title: 'Adicionar mesas', onb_tables_sub: 'Dê a cada mesa um nome ou número e defina o número de lugares.',
    onb_col_name: 'Nome / Número', onb_col_seats: 'Lugares', onb_col_area: 'Zona',
    onb_add_table: '+ Adicionar outra mesa', onb_hours_title: 'Horário de funcionamento',
    onb_hours_sub: 'A IA usa estes dados para saber quando aceitar reservas.',
    onb_finish: 'Concluir configuração →', onb_done_title: 'Tudo pronto!',
    onb_done_sub: 'O Seva está pronto para receber reservas. Pode ajustar tudo nas Configurações.',
    onb_go_dashboard: 'Ir ao painel →', onb_lang_title: 'Escolha o seu idioma', onb_lang_sub: 'Selecione o idioma da app. Pode alterá-lo nas Configurações.',
    monday: 'Segunda', tuesday: 'Terça', wednesday: 'Quarta', thursday: 'Quinta',
    friday: 'Sexta', saturday: 'Sábado', sunday: 'Domingo', closed: 'Fechado',
  },

  nl: {
    operations: 'Operaties', venue: 'Locatie', insights: 'Inzichten', manage: 'Beheer',
    today: 'Vandaag', thisWeek: 'Deze week', reservations: 'Reserveringen', newBooking: 'Nieuwe boeking',
    aiBookings: 'AI-boekingen', floorPlan: 'Plattegrond', capacity: 'Capaciteit',
    analytics: 'Statistieken', waitlist: 'Wachtlijst', tables: 'Tafels', menu: 'Menu',
    settings: 'Instellingen', signOut: 'Uitloggen', management: 'Beheer',
    save: 'Opslaan', saving: 'Opslaan…', cancel: 'Annuleren', loading: 'Laden…',
    create: 'Aanmaken', delete: 'Verwijderen', edit: 'Bewerken', back: 'Terug', next: 'Volgende', done: 'Klaar', confirm: 'Bevestigen',
    onb_welcome: 'Welkom bij Seva', onb_welcome_sub: 'Laten we uw restaurant in een paar stappen instellen.',
    onb_step_tables: 'Tafels toevoegen', onb_step_hours: 'Openingstijden instellen', onb_lets_go: 'Beginnen →',
    onb_tables_title: 'Tafels toevoegen', onb_tables_sub: 'Geef elke tafel een naam of nummer en het aantal zitplaatsen.',
    onb_col_name: 'Naam / Nummer', onb_col_seats: 'Zitplaatsen', onb_col_area: 'Zone',
    onb_add_table: '+ Nog een tafel toevoegen', onb_hours_title: 'Uw openingstijden',
    onb_hours_sub: 'De AI gebruikt deze informatie om te weten wanneer reserveringen geaccepteerd worden.',
    onb_finish: 'Instelling voltooien →', onb_done_title: 'Alles is klaar!',
    onb_done_sub: 'Seva is klaar om reserveringen te ontvangen. U kunt alles aanpassen in Instellingen.',
    onb_go_dashboard: 'Naar dashboard →', onb_lang_title: 'Kies uw taal', onb_lang_sub: 'Selecteer de taal van de app. U kunt dit later wijzigen in Instellingen.',
    monday: 'Maandag', tuesday: 'Dinsdag', wednesday: 'Woensdag', thursday: 'Donderdag',
    friday: 'Vrijdag', saturday: 'Zaterdag', sunday: 'Zondag', closed: 'Gesloten',
  },

  pl: {
    operations: 'Operacje', venue: 'Lokal', insights: 'Statystyki', manage: 'Zarządzanie',
    today: 'Dzisiaj', thisWeek: 'Ten tydzień', reservations: 'Rezerwacje', newBooking: 'Nowa rezerwacja',
    aiBookings: 'Rezerwacje AI', floorPlan: 'Plan sali', capacity: 'Pojemność',
    analytics: 'Analityka', waitlist: 'Lista oczekujących', tables: 'Stoły', menu: 'Menu',
    settings: 'Ustawienia', signOut: 'Wyloguj', management: 'Zarządzanie',
    save: 'Zapisz', saving: 'Zapisywanie…', cancel: 'Anuluj', loading: 'Ładowanie…',
    create: 'Utwórz', delete: 'Usuń', edit: 'Edytuj', back: 'Wstecz', next: 'Dalej', done: 'Gotowe', confirm: 'Potwierdź',
    onb_welcome: 'Witamy w Seva', onb_welcome_sub: 'Skonfigurujmy Twoją restaurację w kilku krokach.',
    onb_step_tables: 'Dodaj stoły', onb_step_hours: 'Ustaw godziny otwarcia', onb_lets_go: 'Zaczynamy →',
    onb_tables_title: 'Dodaj stoły', onb_tables_sub: 'Nadaj każdemu stołowi nazwę lub numer i liczbę miejsc.',
    onb_col_name: 'Nazwa / Numer', onb_col_seats: 'Miejsca', onb_col_area: 'Strefa',
    onb_add_table: '+ Dodaj kolejny stół', onb_hours_title: 'Godziny otwarcia',
    onb_hours_sub: 'AI używa tych danych, aby wiedzieć kiedy akceptować rezerwacje.',
    onb_finish: 'Zakończ konfigurację →', onb_done_title: 'Wszystko gotowe!',
    onb_done_sub: 'Seva jest gotowy do przyjmowania rezerwacji. Możesz wszystko dostosować w Ustawieniach.',
    onb_go_dashboard: 'Przejdź do panelu →', onb_lang_title: 'Wybierz język', onb_lang_sub: 'Wybierz język aplikacji. Możesz go zmienić później w Ustawieniach.',
    monday: 'Poniedziałek', tuesday: 'Wtorek', wednesday: 'Środa', thursday: 'Czwartek',
    friday: 'Piątek', saturday: 'Sobota', sunday: 'Niedziela', closed: 'Zamknięte',
  },

  tr: {
    operations: 'Operasyonlar', venue: 'Mekan', insights: 'İstatistikler', manage: 'Yönetim',
    today: 'Bugün', thisWeek: 'Bu hafta', reservations: 'Rezervasyonlar', newBooking: 'Yeni rezervasyon',
    aiBookings: 'AI rezervasyonları', floorPlan: 'Kat planı', capacity: 'Kapasite',
    analytics: 'Analizler', waitlist: 'Bekleme listesi', tables: 'Masalar', menu: 'Menü',
    settings: 'Ayarlar', signOut: 'Çıkış yap', management: 'Yönetim',
    save: 'Kaydet', saving: 'Kaydediliyor…', cancel: 'İptal', loading: 'Yükleniyor…',
    create: 'Oluştur', delete: 'Sil', edit: 'Düzenle', back: 'Geri', next: 'İleri', done: 'Tamam', confirm: 'Onayla',
    onb_welcome: "Seva'ya Hoşgeldiniz", onb_welcome_sub: 'Restoranınızı birkaç adımda kuralım.',
    onb_step_tables: 'Masalarınızı ekleyin', onb_step_hours: 'Çalışma saatlerinizi ayarlayın', onb_lets_go: 'Başlayalım →',
    onb_tables_title: 'Masalarınızı ekleyin', onb_tables_sub: 'Her masaya bir isim veya numara ve koltuk sayısı verin.',
    onb_col_name: 'İsim / Numara', onb_col_seats: 'Koltuklar', onb_col_area: 'Alan',
    onb_add_table: '+ Başka masa ekle', onb_hours_title: 'Çalışma saatleriniz',
    onb_hours_sub: 'AI, rezervasyonları ne zaman kabul edeceğini bilmek için bunu kullanır.',
    onb_finish: 'Kurulumu tamamla →', onb_done_title: 'Her şey hazır!',
    onb_done_sub: "Seva rezervasyon almaya hazır. Her şeyi Ayarlar'dan düzenleyebilirsiniz.",
    onb_go_dashboard: 'Panele git →', onb_lang_title: 'Dilinizi seçin', onb_lang_sub: "Uygulama dilini seçin. Bunu daha sonra Ayarlar'dan değiştirebilirsiniz.",
    monday: 'Pazartesi', tuesday: 'Salı', wednesday: 'Çarşamba', thursday: 'Perşembe',
    friday: 'Cuma', saturday: 'Cumartesi', sunday: 'Pazar', closed: 'Kapalı',
  },

  ru: {
    operations: 'Операции', venue: 'Заведение', insights: 'Аналитика', manage: 'Управление',
    today: 'Сегодня', thisWeek: 'Эта неделя', reservations: 'Бронирования', newBooking: 'Новое бронирование',
    aiBookings: 'Брони ИИ', floorPlan: 'План зала', capacity: 'Вместимость',
    analytics: 'Статистика', waitlist: 'Лист ожидания', tables: 'Столы', menu: 'Меню',
    settings: 'Настройки', signOut: 'Выйти', management: 'Управление',
    save: 'Сохранить', saving: 'Сохранение…', cancel: 'Отмена', loading: 'Загрузка…',
    create: 'Создать', delete: 'Удалить', edit: 'Изменить', back: 'Назад', next: 'Далее', done: 'Готово', confirm: 'Подтвердить',
    onb_welcome: 'Добро пожаловать в Seva', onb_welcome_sub: 'Давайте настроим ваш ресторан за несколько шагов.',
    onb_step_tables: 'Добавить столы', onb_step_hours: 'Установить часы работы', onb_lets_go: 'Начать →',
    onb_tables_title: 'Добавить столы', onb_tables_sub: 'Дайте каждому столу имя или номер и количество мест.',
    onb_col_name: 'Название / Номер', onb_col_seats: 'Места', onb_col_area: 'Зона',
    onb_add_table: '+ Добавить ещё стол', onb_hours_title: 'Часы работы',
    onb_hours_sub: 'ИИ использует это, чтобы знать, когда принимать бронирования.',
    onb_finish: 'Завершить настройку →', onb_done_title: 'Всё готово!',
    onb_done_sub: 'Seva готов принимать бронирования. Всё можно изменить в Настройках.',
    onb_go_dashboard: 'Перейти в панель →', onb_lang_title: 'Выберите язык', onb_lang_sub: 'Выберите язык приложения. Его можно изменить позже в Настройках.',
    monday: 'Понедельник', tuesday: 'Вторник', wednesday: 'Среда', thursday: 'Четверг',
    friday: 'Пятница', saturday: 'Суббота', sunday: 'Воскресенье', closed: 'Закрыто',
  },

  ar: {
    operations: 'العمليات', venue: 'المكان', insights: 'التحليلات', manage: 'الإدارة',
    today: 'اليوم', thisWeek: 'هذا الأسبوع', reservations: 'الحجوزات', newBooking: 'حجز جديد',
    aiBookings: 'حجوزات الذكاء الاصطناعي', floorPlan: 'مخطط الطابق', capacity: 'الطاقة الاستيعابية',
    analytics: 'الإحصائيات', waitlist: 'قائمة الانتظار', tables: 'الطاولات', menu: 'القائمة',
    settings: 'الإعدادات', signOut: 'تسجيل الخروج', management: 'الإدارة',
    save: 'حفظ', saving: 'جارٍ الحفظ…', cancel: 'إلغاء', loading: 'جارٍ التحميل…',
    create: 'إنشاء', delete: 'حذف', edit: 'تعديل', back: 'رجوع', next: 'التالي', done: 'تم', confirm: 'تأكيد',
    onb_welcome: 'مرحباً بك في Seva', onb_welcome_sub: 'لنقم بإعداد مطعمك في خطوات سريعة.',
    onb_step_tables: 'أضف طاولاتك', onb_step_hours: 'حدد ساعات العمل', onb_lets_go: 'هيا نبدأ →',
    onb_tables_title: 'أضف طاولاتك', onb_tables_sub: 'امنح كل طاولة اسماً أو رقماً وحدد عدد المقاعد.',
    onb_col_name: 'الاسم / الرقم', onb_col_seats: 'المقاعد', onb_col_area: 'المنطقة',
    onb_add_table: '+ إضافة طاولة أخرى', onb_hours_title: 'ساعات العمل',
    onb_hours_sub: 'يستخدم الذكاء الاصطناعي هذه المعلومات لمعرفة متى يقبل الحجوزات.',
    onb_finish: 'إنهاء الإعداد →', onb_done_title: 'كل شيء جاهز!',
    onb_done_sub: 'Seva جاهز لاستقبال الحجوزات. يمكنك تعديل كل شيء في الإعدادات.',
    onb_go_dashboard: 'الذهاب إلى لوحة التحكم →', onb_lang_title: 'اختر لغتك', onb_lang_sub: 'اختر لغة التطبيق. يمكنك تغييرها لاحقاً في الإعدادات.',
    monday: 'الاثنين', tuesday: 'الثلاثاء', wednesday: 'الأربعاء', thursday: 'الخميس',
    friday: 'الجمعة', saturday: 'السبت', sunday: 'الأحد', closed: 'مغلق',
  },

  ja: {
    operations: '運営', venue: '店舗', insights: '分析', manage: '管理',
    today: '今日', thisWeek: '今週', reservations: '予約', newBooking: '新規予約',
    aiBookings: 'AI予約', floorPlan: 'フロアプラン', capacity: '収容人数',
    analytics: '統計', waitlist: '順番待ち', tables: 'テーブル', menu: 'メニュー',
    settings: '設定', signOut: 'サインアウト', management: '管理',
    save: '保存', saving: '保存中…', cancel: 'キャンセル', loading: '読み込み中…',
    create: '作成', delete: '削除', edit: '編集', back: '戻る', next: '次へ', done: '完了', confirm: '確認',
    onb_welcome: 'Sevaへようこそ', onb_welcome_sub: 'レストランをいくつかのステップで設定しましょう。',
    onb_step_tables: 'テーブルを追加', onb_step_hours: '営業時間を設定', onb_lets_go: '始めましょう →',
    onb_tables_title: 'テーブルを追加', onb_tables_sub: '各テーブルに名前か番号と座席数を設定してください。',
    onb_col_name: '名前 / 番号', onb_col_seats: '席数', onb_col_area: 'エリア',
    onb_add_table: '+ テーブルを追加', onb_hours_title: '営業時間',
    onb_hours_sub: 'AIはこの情報を使って予約を受け付ける時間を判断します。',
    onb_finish: '設定を完了 →', onb_done_title: '準備完了！',
    onb_done_sub: 'Sevaは予約を受け付ける準備ができました。設定からいつでも変更できます。',
    onb_go_dashboard: 'ダッシュボードへ →', onb_lang_title: '言語を選択', onb_lang_sub: 'アプリの言語を選んでください。後で設定から変更できます。',
    monday: '月曜日', tuesday: '火曜日', wednesday: '水曜日', thursday: '木曜日',
    friday: '金曜日', saturday: '土曜日', sunday: '日曜日', closed: '定休日',
  },

  zh: {
    operations: '运营', venue: '场地', insights: '分析', manage: '管理',
    today: '今天', thisWeek: '本周', reservations: '预订', newBooking: '新预订',
    aiBookings: 'AI预订', floorPlan: '平面图', capacity: '容量',
    analytics: '统计', waitlist: '候补名单', tables: '桌位', menu: '菜单',
    settings: '设置', signOut: '退出', management: '管理',
    save: '保存', saving: '保存中…', cancel: '取消', loading: '加载中…',
    create: '创建', delete: '删除', edit: '编辑', back: '返回', next: '下一步', done: '完成', confirm: '确认',
    onb_welcome: '欢迎使用 Seva', onb_welcome_sub: '让我们通过几个简单步骤设置您的餐厅。',
    onb_step_tables: '添加桌位', onb_step_hours: '设置营业时间', onb_lets_go: '开始 →',
    onb_tables_title: '添加桌位', onb_tables_sub: '为每张桌子设置名称或编号及座位数。',
    onb_col_name: '名称 / 编号', onb_col_seats: '座位数', onb_col_area: '区域',
    onb_add_table: '+ 添加桌位', onb_hours_title: '营业时间',
    onb_hours_sub: 'AI使用此信息来了解何时接受预订。',
    onb_finish: '完成设置 →', onb_done_title: '一切就绪！',
    onb_done_sub: 'Seva已准备好接受预订。您随时可以在设置中调整。',
    onb_go_dashboard: '前往仪表板 →', onb_lang_title: '选择您的语言', onb_lang_sub: '选择应用语言。您可以稍后在设置中更改。',
    monday: '星期一', tuesday: '星期二', wednesday: '星期三', thursday: '星期四',
    friday: '星期五', saturday: '星期六', sunday: '星期日', closed: '休息',
  },

  ko: {
    operations: '운영', venue: '장소', insights: '분석', manage: '관리',
    today: '오늘', thisWeek: '이번 주', reservations: '예약', newBooking: '새 예약',
    aiBookings: 'AI 예약', floorPlan: '좌석 배치도', capacity: '수용 인원',
    analytics: '통계', waitlist: '대기자 명단', tables: '테이블', menu: '메뉴',
    settings: '설정', signOut: '로그아웃', management: '관리',
    save: '저장', saving: '저장 중…', cancel: '취소', loading: '로딩 중…',
    create: '만들기', delete: '삭제', edit: '편집', back: '뒤로', next: '다음', done: '완료', confirm: '확인',
    onb_welcome: 'Seva에 오신 것을 환영합니다', onb_welcome_sub: '몇 가지 간단한 단계로 레스토랑을 설정해 보겠습니다.',
    onb_step_tables: '테이블 추가', onb_step_hours: '영업 시간 설정', onb_lets_go: '시작하기 →',
    onb_tables_title: '테이블 추가', onb_tables_sub: '각 테이블에 이름이나 번호와 좌석 수를 설정하세요.',
    onb_col_name: '이름 / 번호', onb_col_seats: '좌석', onb_col_area: '구역',
    onb_add_table: '+ 테이블 추가', onb_hours_title: '영업 시간',
    onb_hours_sub: 'AI는 이 정보를 사용하여 예약을 수락할 시간을 파악합니다.',
    onb_finish: '설정 완료 →', onb_done_title: '모든 준비 완료!',
    onb_done_sub: 'Seva가 예약을 받을 준비가 되었습니다. 설정에서 언제든지 변경할 수 있습니다.',
    onb_go_dashboard: '대시보드로 이동 →', onb_lang_title: '언어 선택', onb_lang_sub: '앱 언어를 선택하세요. 나중에 설정에서 변경할 수 있습니다.',
    monday: '월요일', tuesday: '화요일', wednesday: '수요일', thursday: '목요일',
    friday: '금요일', saturday: '토요일', sunday: '일요일', closed: '휴무',
  },
};

const LANG_KEY = 'seva_ui_language';

export function getLang() {
  return localStorage.getItem(LANG_KEY) || 'en';
}

export function setLang(code) {
  localStorage.setItem(LANG_KEY, code);
}

export function t(key, lang) {
  const l = lang || getLang();
  const dict = TRANSLATIONS[l] || TRANSLATIONS.en;
  return dict[key] || TRANSLATIONS.en[key] || key;
}

export function isRTL(lang) {
  const l = lang || getLang();
  return !!(LANGUAGES.find(x => x.code === l) || {}).rtl;
}
